import React from 'react'
import View from './view'

const BookingList = ({ ...props }) => {
    return <View {...props} />
}

export default BookingList